// Node Modules
import { nanoid } from 'nanoid';
import { RichText } from 'prismic-reactjs';

// Components
import Button from '@/components/global-components/Button';

// Themes
import theme from '@/themes/index';

const Question = ({
  isDesktop,
  faq,
}) => {
  console.log(faq);
  return (
    <>
      <div className='question-container'>
        <h6>{faq.node.question}</h6>
        <RichText render={faq.node.answer} />
        {/* <div className='buttons-container'>
          {buttons?.filter(i => !i.button.turnOffForDetail).map(item => (
            <Button
              className={item.button.style.toLowerCase()}
              key={nanoid()}
              text={item.button.title}
              href={`${item.button.url}${item.button.appendId ? '/'+ id : ''}`}
              target={item.button.openInAnotherPage ? '_blank' : '_self'}
              styles={{
                width: isDesktop ? 'fit-content' : '100%',
                padding: '0 1rem',
              }}></Button>
          ))}
        </div> */}
      </div>
      <style jsx>{`
        div.buttons-container {
          display: flex;
          flex-direction: column;
          width: 100%;
          gap: 1rem;
          align-items: center;
        }
        div.question-container {
          margin-bottom: 3.5rem;
        }
        div.question-container h6 {
          color: ${theme.fontColors.optional5};
          font-family: ${theme.fontFamilies.montserratBold};
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          div.buttons-container {
            flex-direction: row;
            gap: 2rem;
            justify-content: center;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.buttons-container {
            justify-content: left;
          }
          div.question-container {
            margin-bottom: 4.5rem;
          }
        }
      `}</style>
      <style global jsx>{`
        div.question-container p {
          font-size: 1rem;
          line-height: 1.5rem;
          text-align: justify;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.question-container p {
            font-size: 1.375rem;
            line-height: 1.875rem;
          }
        }
      `}</style>
    </>
  );
};

export default Question;
